import { Button, message } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
const copyURLtoClipboard = urlString => navigator.clipboard.writeText(urlString).then(() => message.success(<div>Page URL copied. <br />	Share this link with teachers and admins.</div>), () => message.error('Failed to copy URL'));
const ShareButtonLink = ({
  urlString,
  ...buttonProps
}) => <Button {...buttonProps} icon={<LinkOutlined />} onClick={() => copyURLtoClipboard(urlString ?? window.location.toString())} disabled={!navigator.clipboard} data-sentry-element="Button" data-sentry-component="ShareButtonLink" data-sentry-source-file="ShareLinkButton.jsx">
		Share with Teachers
	</Button>;
export default ShareButtonLink;